module.exports = __webpack_public_path__ + "static/img/how_it_works.5928d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/how_it_works.png
// module id = Qn0A
// module chunks = 14